import { ChequeGiroLiteModel, useGetChequeGiros } from 'api-hooks/cheque-giro';
import { NavigationRoutes } from 'common/constants';
import { CommissionFilterStatusEnum } from 'common/constants/enum';
import { IColumn } from 'components/elements/table-component/table-component';
import useGetCrudPermission from 'hooks/use-get-crud-permission';
import useGetListParamsValue from 'hooks/use-get-list-params-value';
import useTranslation from 'next-translate/useTranslation';
import * as React from 'react';
import UniskaiStatusBadges from 'templates/form/uniskai-status-badges';
import UniskaiListTemplate from 'templates/list/uniskai-list-template';

export default function ChequeGiroList() {
  const { t } = useTranslation();
  const { queryPage } = useGetListParamsValue();
  const [page, setPage] = React.useState(queryPage);

  const columns = React.useMemo<IColumn<ChequeGiroLiteModel>[]>(
    () => [
      {
        header: t('common:name'),
        accessorKey: 'name',
        minSize: 250,
        sortName: 'name',
      },
      {
        header: t('common:bank_code'),
        accessorKey: 'bankCode',
        minSize: 500,
        sortName: 'bank_code',
      },
      {
        header: t('common:status'),
        accessorKey: 'isActive',
        minSize: 100,
        sortName: 'is_active',
        cell: ({ row }) => {
          return (
            <UniskaiStatusBadges
              status={
                row.original.isActive
                  ? CommissionFilterStatusEnum.Active
                  : CommissionFilterStatusEnum.Inactive
              }
            />
          );
        },
      },
    ],
    [t],
  );

  const permission = useGetCrudPermission('cheque-giros');

  return (
    <UniskaiListTemplate
      title={t(`pathname:${NavigationRoutes.ChequeGirosList}`)}
      addNavigation={NavigationRoutes.ChequeGirosCreate}
      showAdd={permission.create}
      columns={columns}
      useQuery={useGetChequeGiros}
      page={page}
      setPage={setPage}
      tableName={NavigationRoutes.ChequeGirosList}
      queryInput={{
        params: {
          page,
        },
      }}
      rowLink={
        permission.view
          ? (row) => ({
              pathname: NavigationRoutes.ChequeGirosView,
              query: { id: row.original.id },
            })
          : undefined
      }
    />
  );
}
